import { Texture } from '@pixi/core';
import { Container } from '@pixi/display';
import { Sprite } from '@pixi/sprite';
import { Text } from '@pixi/text';

import { Shared } from '../App';

class RecFrameCorner extends Container
{
    constructor(size = 80)
    {
        super();

        const hor = new Sprite(Texture.WHITE);
        const ver = new Sprite(Texture.WHITE);

        this.addChild(hor);
        this.addChild(ver);
        hor.width = size;
        hor.height = size * 0.2;
        ver.width = size * 0.2;
        ver.height = size;
    }
}

export class RecFrame extends Container
{
    private topLeft: RecFrameCorner;
    private topRight: RecFrameCorner;
    private botRight: RecFrameCorner;
    private botLeft: RecFrameCorner;
    private label: Text;

    constructor()
    {
        super();

        this.topLeft = new RecFrameCorner();
        this.addChild(this.topLeft);

        this.topRight = new RecFrameCorner();
        this.addChild(this.topRight);

        this.botRight = new RecFrameCorner();
        this.addChild(this.botRight);

        this.botLeft = new RecFrameCorner();
        this.addChild(this.botLeft);

        this.label = new Text(`REC`, {
            fontFamily: 'lubalin',
            fill: 0xFF0000,
            align: 'left',
            fontSize: 20,
        });
        this.addChild(this.label);

        Shared.game.hud.view.addChild(this);
        this.renderable = false;
        this.resize(Shared.game.app.resize.width, Shared.game.app.resize.height);
        this.updateTransform();
    }

    public updateTransform(): void
    {
        super.updateTransform();
        this.renderable = Shared.game.replay.recording;
        if (!this.renderable) return;
        this.resize(Shared.game.app.resize.width, Shared.game.app.resize.height);
        this.alpha = (Math.round(Shared.game.time['_lastTime'] * 0.005) % 2) ? 1 : 0;
    }

    private resize(w: number, h: number): void
    {
        w -= 20;
        h -= 20;

        this.topLeft.x = -w / 2;
        this.topLeft.y = -h / 2;
        this.topLeft.scale.set(1, 1);

        this.topRight.x = w / 2;
        this.topRight.y = -h / 2;
        this.topRight.scale.set(-1, 1);

        this.botRight.x = w / 2;
        this.botRight.y = h / 2;
        this.botRight.scale.set(-1, -1);

        this.botLeft.x = -w / 2;
        this.botLeft.y = h / 2;
        this.botLeft.scale.set(1, -1);

        this.label.x = this.topLeft.x + 90;
        this.label.y = this.topLeft.y - 6;
    }
}

